module.exports = __webpack_public_path__ + "static/media/done-all.3bf454cc.svg";